<div>
    <div class="mt-4">
        <div class=" row mb-2" *ngIf="!isLoadingInquiries">
          <div class="col-md-8">
            <div class="h-100 d-flex align-items-center ">
              <h5 class="bold">Diagnosis Inquiries</h5>
            </div>
          </div> 
          <div class="col" *ngIf="inquiriesData?.length>0">
            <input 
              type="text" 
              placeholder="Search"
              name="searchInquiry"
              (keyup)="filterDiagnosisInquiry($event)"
              class="px-2 py-1"
            >
          </div>
        </div>
        <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingInquiries">
          <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
        </div>
        <div *ngIf="!isLoadingInquiries">
          <div *ngIf="inquiriesData?.length===0" style="text-align: center;">
            No inquiries added yet...
          </div>
          <div *ngIf="inquiriesData?.length>0">
            <table class="table table-bordered table-primary">
              <thead>
                <tr class="text-uppercase">
                  <th>#</th>
                  <th scope="col">username</th>
                  <th scope="col">user type</th>
                  <th scope="col">description</th>
                  <th scope="col">Contact</th>
                  <th scope="col">Handled At</th>
                  <th scope="col">Date</th>
                  <th scope="col">media</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filterDiagnosisInfo | paginate: { id: 'paginate1', itemsPerPage: count, currentPage: inqPage };
                let i = index" [class.resolved]="row.status === 'resolved' ">
                  <td>{{ (inqPage - 1) * count + i + 1 }}</td>
                  <td>
                      <div>{{row.username}}</div>
                      <div *ngIf="row.status === 'not resolved'">
                        <span class="badge badge-pill user-type ml-2 smf">{{row.status}}</span>
                      </div>
                  </td>
                  <td>{{row.user_type}}</td>
                  <td>{{row.description}}</td>
                  <td>{{row.user_contact}}</td>
                  <!-- <td 
                    [className]="row.answered_status.toLowerCase()"
                  >
                    <span class="dot mr-2"></span>
                    {{row.answered_status}}
                  </td> -->
                  <td>{{row.respondedAt?moment(row.respondedAt,'YYYY-MM-DD').format('MMMM Do YYYY'):''}}</td>
                  <td>{{row.time?moment(row.time,'YYYY-MM-DD').format('MMMM Do YYYY'):''}}</td>
                  <td>
                    <div class="mult_images">
                      <div *ngFor="let photo of row.media">
                        <div class="img-holder mb-1" *ngIf="photo.photo_url"> 
                          <img src='{{ "https://storage.googleapis.com/ezyagric-media/" + photo.photo_url }}'
                          />
                        </div>
                      </div>
                    </div> 
                  </td>
                  <td *ngIf="row.status !== 'resolved'">
                    <div class="dropdown">
                      <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        ACTION
                      </button>
                      <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                        <button
                          class="dropdown-item suspend"
                          data-toggle="modal"
                          data-target="#replyInquiry"
                          (click)="setSingleInquiriesViewData(row)"
                        >
                          View details
                        </button>
                      </div>
                    </div>
                  </td>
                  <td *ngIf="row.status === 'resolved'">
                    <p class="resolved-tab">Resolved</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="!isLoadingInquiries">
              <nav>
                <pagination-controls id="paginate1" (pageChange)="inqPage = $event"></pagination-controls>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!-- Beginning of make recommendation modal -->
      <div class="modal fade" id="replyInquiry" style="overflow: auto;">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="card modal-content container-fluid">
              <div class="modal-header no-border">
                  <h5 class="modal-title text text-primary" style="font-weight: bold;" id="modal-basic-title">Reply to inquiry</h5>
                  <div class="float-right" *ngIf="!showImage">
                    <button
                      type="button" 
                      class="close close-btn" 
                      data-dismiss="modal"
                      pTooltip="All unsaved changes will be lost once you close the form" 
                      tooltipPosition="right"
                      aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
              </div>
  
              <div class="modal-body agronomical-view-details" *ngIf="!showImage">
                <!-- <span class="text-center alert alert-danger" *ngIf="singleInquiryDataError">{{ message }}</span> -->
                <div class="container-fluid" *ngIf="singleInquiryData">
                  <div class="row">
                    <div class="col-md-3">Name: </div>
                    <div class="col-md-9">{{singleInquiryData.username}}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">App used: </div>
                    <div class="col-md-9">{{singleInquiryData.user_type}}</div>
                </div>
                <div class="row">
                  <div class="col-md-3">Phone number: </div>
                  <div class="col-md-9">{{singleInquiryData.user_contact}}</div>
                </div>
                <div class="row">
                    <div class="col-md-3">Description</div>
                    <div class="col-md-9">{{singleInquiryData.description}}</div>
                </div>
                <div class="row">
                  <form
                    (ngSubmit)="replyToDiagnosisInquiry(singleInquiryData.id)" 
                    class="px-2 py-2"
                    id="replyInquiryInfo"
                    [formGroup]="replyInquiryForm"
                  >
                    <div class="form-group">
                      <label for="media">Media</label>
                      <div class="mult_images_card">
                        <div formArrayName="media" *ngFor="let media of editDiagnosisReply().controls; let i = index">
                          <div class="form-group" [formGroupName]="i">
                            <div class="card" style="width: 20rem;">
                              <div class="card-body">
                                <div *ngIf="media.value.photo_url">
                                  <img
                                    class="img-responsive" 
                                    src='{{ "https://storage.googleapis.com/ezyagric-media/" + media.value.photo_url }}'
                                    alt="agronomy image"
                                    style="width: 100%; height: 100px;"
                                    (click)="enlargeImage($event)"
                                  >
                                </div>
                                <br>
                                <label for="media">Possible Disease</label>
                                <input 
                                  type="text" 
                                  class="form-control change-input-field" 
                                  placeholder="Enter possible diseases separated by comma" 
                                  formControlName="annotation"
                                />
                                <br>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="inputs">General Recommendation</label>
                      <textarea 
                        type="text" 
                        class="form-control change-input-field" 
                        placeholder="Enter General Recommendation" 
                        formControlName="general_recommendation"
                      ></textarea>
                      
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="inputs">Inputs</label>
                      <p-multiSelect
                        autoWidth="false"
                        [style]="{'width':'100%', 'height': '35px'}"
                        [options] = "inputsToSelect"
                        id="selectInput"
                        formControlName="recommend_input"
                      >
                      </p-multiSelect>
                    </div>
                    <br>
                    <div class="form-group">
                      <label for="input_quantites"
                      >Recommended Input Quantities</label>
                      <input 
                        type="text" 
                        class="form-control change-input-field" 
                        placeholder="Enter quantities separated by commas" 
                        formControlName="input_quantites"
                        pTooltip="The quantites should be entered in same order as the inputs above and separated by commas"
                        tooltipPosition="right"
                      />
                    </div>
                    <div>
                      <button type="submit" class="btn btn-primary float-right" [disabled]="!replyInquiryForm.valid">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm
                          text-white change-loading" role="status"></span>
                        <span *ngIf="loading" class="mx-2">Loading...</span>
                        <span *ngIf="!loading">
                          Save changes
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
                </div>
              </div>
              <div class="modal-body" *ngIf="showImage">
                <div class="row">
                  <img
                    class="img-fluid" 
                    src='{{ selectedImage}}'
                    alt="full image"
                  >
                </div>
                <br>
                <button class="btn btn-primary float-right" (click)="closeImageDisplay()">Back to Form</button>
              </div>
          </div>
        </div>
      </div>
</div>